import ErrorIcon from '@mui/icons-material/Error';
import { Button, DialogContentText, IconButton } from '@mui/material';
import React, { useState } from 'react';
import ErrorDialog from '../error-dialog/ErrorDialog';

export interface SimulationDisabledDialogProps {
  reason: string;
}

const SimulationDisabledDialog = ({ reason }: SimulationDisabledDialogProps) => {
  const [showReasonDialog, setShowReasonDialog] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setShowReasonDialog(true)}
        sx={{
          color: theme => theme.palette.error.main,
        }}
      >
        <ErrorIcon />
      </IconButton>

      <ErrorDialog
        title="Simulator can't be started"
        open={showReasonDialog}
        message={
          <DialogContentText color="text.primary" variant="body1">
            {reason}
          </DialogContentText>
        }
      >
        <Button variant="contained" onClick={() => setShowReasonDialog(false)}>
          Dismiss
        </Button>
      </ErrorDialog>
    </>
  );
};

export default SimulationDisabledDialog;
